import type { Masthead, MastheadArtwork, MastheadArtworkDef, ResolvedMasthead } from '@shared/types/Masthead.types';
import { MASTHEAD_URLS } from '@shared/utils/urls';

// Membership-table catalog: one row per artwork, colorway members inside, `lead` fronts the
// admin picker tile. Shared fields (placement/dims) live once per artwork.
// The BE stores only mastheadId (uuid); slug names the S3 asset.
// S3 naming: /marcom-prod/wedding-website-gallery/gallery_thumbnails/art_mastheads/{slug}.png
const MASTHEAD_CATALOG: ReadonlyArray<MastheadArtworkDef> = [
  {
    artworkId: 'boardwalk',
    placement: 'center',
    width: 1600,
    height: 600,
    lead: 'brannan-boardwalk_beige-artmasthead',
    colorways: [
      { mastheadId: '3861fc37-13f6-4001-a92e-48245d5d56d5', slug: 'brannan-boardwalk_beige-artmasthead', swatchColor: '#EFE4D3' },
      { mastheadId: 'e470d7fb-54f4-48c3-8961-c38eece6aa4d', slug: 'brannan-boardwalk_blue-artmasthead', swatchColor: '#CBDAE5' },
      { mastheadId: 'ff2e760f-71e7-44de-862d-aa9523121b1c', slug: 'brannan-boardwalk_green-artmasthead', swatchColor: '#D3D9CF' },
      { mastheadId: '4ee4da00-48e0-44f1-bb32-f2b94ff3af9b', slug: 'brannan-boardwalk_pink-artmasthead', swatchColor: '#F9CDCC' },
      { mastheadId: 'e16f0f13-4aaa-4e55-b490-30239f82d6e9', slug: 'brannan-boardwalk_yellow-artmasthead', swatchColor: '#F6EABB' },
    ],
  },
  {
    artworkId: 'bonsoir',
    placement: 'top',
    width: 1600,
    height: 600,
    lead: 'brannan-bonsoir_black-artmasthead',
    colorways: [
      { mastheadId: 'f73096ad-aeac-4b2e-ab3a-208c8115a8fa', slug: 'brannan-bonsoir_black-artmasthead', swatchColor: '#000000' },
      { mastheadId: '932d91fb-1a4a-4399-afcf-632162271741', slug: 'brannan-bonsoir_blue-artmasthead', swatchColor: '#2F5DAC' },
      { mastheadId: '444c44dc-52df-484d-8d9c-69f4770b023e', slug: 'brannan-bonsoir_green-artmasthead', swatchColor: '#044A4A' },
      { mastheadId: 'aea87f56-7f60-4e07-8c98-6aa17effebfa', slug: 'brannan-bonsoir_orange-artmasthead', swatchColor: '#D86F35' },
      { mastheadId: '761c7f7e-c55c-42a3-8962-9b5ce7b3b6e9', slug: 'brannan-bonsoir_pink-artmasthead', swatchColor: '#D7559D' },
      { mastheadId: 'f83c1e74-1991-4e3a-8eb7-b84f6528d9c7', slug: 'brannan-bonsoir_red-artmasthead', swatchColor: '#D23832' },
    ],
  },
  {
    artworkId: 'charlotte',
    placement: 'top',
    width: 1600,
    height: 600,
    lead: 'brannan-charlotte-artmasthead',
    colorways: [{ mastheadId: '69075030-712d-4ff5-9230-cec42d5306f5', slug: 'brannan-charlotte-artmasthead', swatchColor: '#EFEEE8' }],
  },
  {
    artworkId: 'lorange',
    placement: 'top',
    width: 1600,
    height: 600,
    lead: 'brannan-lorange-artmasthead',
    colorways: [{ mastheadId: '08c7dbf1-94e3-41b8-a222-d5b97ec8dbf7', slug: 'brannan-lorange-artmasthead', swatchColor: '#DE5A2D' }],
  },
  {
    artworkId: 'mirrorball',
    placement: 'top',
    width: 1600,
    height: 600,
    lead: 'brannan-mirrorball_apricot-artmasthead',
    colorways: [
      { mastheadId: '1202ed10-6ea8-4953-ba15-ae5b085f2be3', slug: 'brannan-mirrorball_apricot-artmasthead', swatchColor: '#DD4E23' },
      { mastheadId: 'a856188c-833e-491c-be67-aec56c5d4550', slug: 'brannan-mirrorball_black-artmasthead', swatchColor: '#FFFFFF' },
      { mastheadId: 'e1538296-6698-4cd5-92ea-577abfc3c311', slug: 'brannan-mirrorball_lilac-artmasthead', swatchColor: '#EC2E38' },
      { mastheadId: '192fa2e6-8c35-444f-bc6c-dcac12a97737', slug: 'brannan-mirrorball_midnight-artmasthead', swatchColor: '#A1ADDB' },
      { mastheadId: '2ada2f00-f080-45ab-a47e-6e0417c08eba', slug: 'brannan-mirrorball_neon-artmasthead', swatchColor: '#D7FBE2' },
      { mastheadId: '34f59323-534a-42a1-8e90-f6c7f4a3e4cf', slug: 'brannan-mirrorball_orange-artmasthead', swatchColor: '#FF6F3B' },
      { mastheadId: '8486f147-2e9b-4167-80b1-f433df0328ba', slug: 'brannan-mirrorball_pink-artmasthead', swatchColor: '#D71E24' },
      { mastheadId: '9b0570d3-4733-410b-b37d-3596db3ea3d7', slug: 'brannan-mirrorball_sky-artmasthead', swatchColor: '#629C4E' },
      { mastheadId: '180ca975-efed-4c2b-b6b5-596a73178007', slug: 'brannan-mirrorball_white-artmasthead', swatchColor: '#000000' },
    ],
  },
  {
    artworkId: 'regal_garden',
    placement: 'center',
    width: 1600,
    height: 600,
    lead: 'brannan-regal_garden-artmasthead',
    colorways: [{ mastheadId: '3ec8e075-6045-4ffc-b3e6-3d366b1e8232', slug: 'brannan-regal_garden-artmasthead', swatchColor: '#FCE3C7' }],
  },
];

/** Catalog hydrated per artwork (colorways carry the artwork's shared fields) — drives the admin picker grid. */
export const MASTHEAD_ARTWORKS: ReadonlyArray<MastheadArtwork> = MASTHEAD_CATALOG.map(({ artworkId, placement, width, height, lead, colorways }) => {
  const hydrated: ReadonlyArray<Masthead> = colorways.map(colorway => ({ ...colorway, artworkId, placement, width, height }));
  return {
    artworkId,
    placement,
    lead: hydrated.find(colorway => colorway.slug === lead) ?? hydrated[0],
    colorways: hydrated,
  };
});

/** Flat list of every selectable colorway. */
export const MASTHEADS: ReadonlyArray<Masthead> = MASTHEAD_ARTWORKS.flatMap(artwork => artwork.colorways);

// Indexed by mastheadId (the canonical BE-stored uuid) and by slug, so template previews
// and the preview-bus can look up by the readable slug.
const mastheadsMap = new Map(MASTHEADS.flatMap(masthead => [[masthead.mastheadId, masthead] as const, [masthead.slug, masthead] as const]));

/**
 * Resolve a stored mastheadId (or slug) into a renderable accent. Returns
 * null when the accent is off or the id doesn't validate against the catalog (render nothing).
 */
export const resolveMasthead = (mastheadId: Maybe<string>): ResolvedMasthead | null => {
  const masthead = mastheadId ? mastheadsMap.get(mastheadId) : undefined;
  if (!masthead) {
    return null;
  }
  return {
    masthead,
    assetUrl: MASTHEAD_URLS.masthead(masthead.slug),
    thumbnailUrl: MASTHEAD_URLS.mastheadThumbnail(masthead.slug),
  };
};
